module.exports = __webpack_public_path__ + "img/blog-10.f340dd13.webp";